import { randomNumber } from '@/src/tools/helper';
import arrayMove from 'array-move';
import { get } from 'lodash';
import React from 'react';
import { Input, OriCheckbox, OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { DeleteIcon } from 'src/components/Icon';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveContentText,
  ResponsiveTabStyle,
} from 'src/components/Modules/Components';
import _ContentPage from 'src/components/Modules/Components/ContentImageDragItem';
import {
  errKeys as contentErr,
  generateNewContentPage,
} from 'src/components/Modules/Components/ContentImageDragItem/tools';
import ModuleStyle from 'src/components/Modules/Components/ModuleStyle';
import Switcher from 'src/components/SectionSwitcher';
import {
  errKeys,
  generateTabContent,
  tabErrorNameGenerator,
} from 'src/constrains/DraggableModules/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
import {
  EModuleWidth,
  EOverflowOption,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveContentPageToShow,
} from 'src/types/common/module';
import css from './css.module.less';

const Option = OriSelect.Option;

const ResponsiveContentTab = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    tabs,
    onItemAdd,
    onItemDelete,
    onItemChange,
    //onItemReselect,
    onItemSort,
    onStaticChange,
    specificError,
    staticData,
    contentPageList,
    breakpoint,
    animations,
    hoverAnimations,
  } = props;
  //console.log('breakpoint', breakpoint);
  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  const isMobile = breakpoint && breakpoint === EPreviewSize.MOBILE;
  const onlyLastTab = (tabs || []).length === 1;
  const draggableId = get(staticData, 'draggableId');
  //const posterType = get(staticData, 'posterType');
  const moduleWidth = get(staticData, 'moduleWidth');
  const leaveGap = get(staticData, 'leaveGap');
  const text = get(staticData, 'moduleText');
  const moduleStyle = get(staticData, 'moduleStyle');
  const animation = get(staticData, 'animation');
  const tabStyle = get(staticData, 'tabStyle');
  const overflowOption = get(staticData, 'overflowOption');
  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const selectedTab = get(staticData, 'selectedTab');

  const shouldHideModuleBkgSetting =
    moduleWidth === EModuleWidth.NONE || moduleWidth === EModuleWidth.FULL;

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnLeaveGapChange = (e) => {
    const leaveGap = e.target.checked;
    onStaticChange({ leaveGap });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTextChange = (ani) => {
    const newText = { ...(text || {}), ...ani };
    onStaticChange({ moduleText: newText });
  };

  const handleTabStyleChange = (tab) => {
    const newTabStyle = { ...(tabStyle || {}), ...tab };
    onStaticChange({ tabStyle: newTabStyle });
  };

  const handleOnOverflowOptionChange = (overflowOption) => {
    onStaticChange({ overflowOption });
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnTabChange = (index, data) => {
    onItemChange(index, data);
  };

  const handleOnItemDelete = (index, draggableId) => {
    //selectedTab

    if (draggableId === selectedTab) {
      const newTabs = tabs.filter((i) => i.draggableId !== draggableId);

      if (newTabs.length > 0) {
        const newId = get(newTabs, '0.draggableId');

        onStaticChange({ selectedTab: newId });
      }
    }
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const handleOnItemAdd = () => {
    const data = generateTabContent((tabs || []).length + 1);
    onItemAdd([data]);
    //
    if (!selectedTab) {
      const { draggableId } = data;
      onStaticChange({ selectedTab: draggableId });
    }
    //selectedTab
  };

  const handleOnPosterTabChange = (selectedTab) => {
    onStaticChange({ selectedTab });
  };

  //const handleOnPosterNameChange = () => {};

  // const hideGapLarge =
  //   isMobile || (isTablet && posterType === EResponsivePosterType.SIX);
  const childGenerate = (data, index) => {
    const { title, draggableId } = data;
    const nameErrK = errKeys.ResponsiveContentTab.tabName;
    const nameErr = specificError[`${draggableId}${nameErrK}`] || [];

    return (
      <div className={css.tabContainer}>
        <ItemWrapper
          size='small'
          titleClassName={css.titleContainer}
          title={
            <div className={css.titleTitleContainer}>
              {getI18n('general.tabTitle')}
              {!onlyLastTab && (
                <DeleteIcon
                  onDelete={() => {
                    // console.log('delete');
                    handleOnItemDelete(index, draggableId);
                  }}
                  //iconClassName={css.deleteIcon}
                />
              )}
            </div>
          }>
          <Input
            error={nameErr.length > 0}
            help={nameErr.join('')}
            size='large'
            maxLength={100}
            value={title}
            onChange={(title) => {
              onItemChange(index, { title });
            }}
          />
        </ItemWrapper>
      </div>
    );
  };

  return (
    <React.Fragment>
      <Section size='small' bottomBorder>
        {!isConvertible && (
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
        )}

        <React.Fragment>
          <div className={css.gapContainer}>
            <OriCheckbox checked={leaveGap} onChange={handleOnLeaveGapChange}>
              {getI18n('general.leavegapbetweencontentpages')}
            </OriCheckbox>
          </div>
        </React.Fragment>
      </Section>
      {isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper title={getI18n('general.overflowItemsDisplayOption')}>
            <OriSelect
              size='large'
              value={overflowOption}
              onChange={handleOnOverflowOptionChange}>
              <OriSelect.Option value={EOverflowOption.AnotherLine}>
                {getI18n('general.shiftToAnotherLine')}
              </OriSelect.Option>
              <OriSelect.Option value={EOverflowOption.Hide}>
                {getI18n('general.hide')}
              </OriSelect.Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}

      <Section size='small' className={css.switcherContainer} bottomBorder>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ModuleStyle
                    hideBkgConfig={shouldHideModuleBkgSetting}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isConvertible}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Text]: {
                    title: getI18n('general.text'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveContentText
                          data={text}
                          onChange={handleTextChange}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                }),

            [EResponsiveCarouselModuleSwitcherType.TabStyle]: {
              title: getI18n('general.tabStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveTabStyle
                    isConvertible={isConvertible}
                    data={tabStyle}
                    onChange={handleTabStyleChange}
                  />
                </div>
              ),
            },
            //
          }}
        />
      </Section>
      {!isConvertible && (
        <DragNDropColumns
          // disabled={!isPrimary}
          // hideAdd={!isPrimary}
          // hideTitle
          titleRightTextClassName={css.tabAddText}
          title={getI18n('general.allTabs')}
          childGenerate={childGenerate}
          data={tabs || []}
          droppableId={`salesChannelContentListPosterTab${draggableId}`}
          onSort={handleItemOnSort}
          hideAdd={true}
          titleRightText={`+ ${getI18n('general.addTab')}`}
          titleRightFunction={handleOnItemAdd}
        />
      )}

      {tabs && tabs.length > 0 && (
        <Section size='small' className={css.switcherContainer}>
          <Switcher
            selectContainer={css.switcher}
            selected={selectedTab}
            onChange={handleOnPosterTabChange}
            allSections={tabs.reduce((pre, now, index) => {
              const { draggableId: dId, title, contentPages } = now;
              let hasError = false;
              contentPages.forEach((poster) => {
                const { draggableId: contentId } = poster;
                const contentPageErrK =
                  errKeys.ResponsiveContentTab.contentPage;
                const imgErrK = errKeys.ResponsiveContentTab.image;
                const subtitleErrK = errKeys.ResponsiveContentTab.subtitle;
                const summaryErrK = errKeys.ResponsiveContentTab.summary;
                const invalidErrK =
                  errKeys.ResponsiveContentTab.contentPageInvalid;
                const contentE =
                  specificError[
                    tabErrorNameGenerator(dId, contentId, contentPageErrK)
                  ] || [];
                const imgE =
                  specificError[
                    tabErrorNameGenerator(dId, contentId, imgErrK)
                  ] || [];
                const subtitleE =
                  specificError[
                    tabErrorNameGenerator(dId, contentId, subtitleErrK)
                  ] || [];
                const summaryE =
                  specificError[
                    tabErrorNameGenerator(dId, contentId, summaryErrK)
                  ] || [];
                const contentPageInvalid =
                  specificError[
                    tabErrorNameGenerator(dId, contentId, invalidErrK)
                  ] || [];
                const err = [
                  ...contentE,
                  ...imgE,
                  ...subtitleE,
                  ...summaryE,
                  ...contentPageInvalid,
                ];
                if (err.length > 0) {
                  hasError = true;
                }
              });
              const relatedErr = Object.keys(specificError).reduce(
                (pre, now) => {
                  if (now.startsWith(dId)) {
                    const lastId = now.split(dId)[1];
                    return { ...pre, [lastId]: specificError[now] };
                  }
                  return pre;
                },
                {},
              );
              //console.log('relatedErr', relatedErr);
              return {
                ...pre,
                [dId]: {
                  title: title,
                  hasError: hasError,
                  child: (
                    <ContentTabs
                      isMobile={isMobile}
                      isConvertible={isConvertible}
                      contentPageList={contentPageList}
                      specificError={relatedErr}
                      draggableId={dId}
                      data={now}
                      onChange={(data) => {
                        //
                        handleOnTabChange(index, data);
                      }}
                    />
                  ),
                },
              };
            }, {})}
          />
        </Section>
      )}
    </React.Fragment>
  );
};

export default ResponsiveContentTab;

// const Animation = (props) => {
//   const { data, onChange, animations } = props;
//   const _animations = [
//     { value: null, label: 'None' },
//     ...(animations || []).map((i) => {
//       const { name, uuid } = i;
//       return { label: name, value: uuid };
//     }),
//   ];
//   const entranceUuid = get(data, 'entranceUuid') || null;
//   const hoverEffectUuid = get(data, 'hoverEffectUuid') || null;
//   return (
//     <React.Fragment>
//       <ItemWrapper size='small' title='Entrance Animation'>
//         <OriSelect
//           size='large'
//           value={entranceUuid}
//           onChange={(entranceUuid) => {
//             onChange({ entranceUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//       <ItemWrapper size='small' title='Hover Effect'>
//         <OriSelect
//           size='large'
//           value={hoverEffectUuid}
//           onChange={(hoverEffectUuid) => {
//             onChange({ hoverEffectUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//     </React.Fragment>
//   );
// };

const ContentTabs = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onChange,
    data,
    draggableId,
    specificError,
    contentPageList,
    isConvertible,
    isMobile,
  } = props;
  // console.log('specificError', specificError);
  const { contentPagesToShow, contentPages } = data;
  const amountErr =
    specificError[`${errKeys.ResponsiveContentTab.contentPagesAmount}`] || [];
  //console.log('specificError', specificError);
  const handleOnContentTypeChange = (contentPagesToShow) => {
    onChange({ contentPagesToShow });
  };
  const renderContentType = () => {
    return [
      <Option
        value={EResponsiveContentPageToShow.One}
        key={EResponsiveContentPageToShow.One}>
        {getI18n('general.oneContentPageOnScreen')}
      </Option>,
      <Option
        value={EResponsiveContentPageToShow.TwoPortrait}
        key={EResponsiveContentPageToShow.TwoPortrait}>
        {getI18n('general.twoContentPagesOnScreen')} (
        {getI18n('general.portrait')})
      </Option>,
      ...(isMobile
        ? []
        : [
            <Option
              value={EResponsiveContentPageToShow.TwoLandscape}
              key={EResponsiveContentPageToShow.TwoLandscape}>
              {getI18n('general.twoContentPagesOnScreen')} (
              {getI18n('general.landscape')})
            </Option>,

            <Option
              value={EResponsiveContentPageToShow.Three}
              key={EResponsiveContentPageToShow.Three}>
              {getI18n('general.threeContentPagesOnScreen')}
            </Option>,
          ]),

      ...(isConvertible
        ? []
        : [
            <Option
              value={EResponsiveContentPageToShow.Four}
              key={EResponsiveContentPageToShow.Four}>
              {getI18n('general.fourContentPagesOnScreen')}
            </Option>,
            <Option
              value={EResponsiveContentPageToShow.Five}
              key={EResponsiveContentPageToShow.Five}>
              {getI18n('general.fiveContentPagesOnScreen')}
            </Option>,
            <Option
              value={EResponsiveContentPageToShow.Six}
              key={EResponsiveContentPageToShow.Six}>
              {getI18n('general.sixContentPagesOnScreen')}
            </Option>,
          ]),
    ];
  };

  const handleOnItemChange = (index, data) => {
    const _contentPages = [...(contentPages || [])];
    _contentPages[index] = { ..._contentPages[index], ...data };
    onChange({ contentPages: _contentPages });
  };

  const handleOnItemDelete = (index) => {
    //console.log('index111', index);
    const _contentPages = [...(contentPages || [])];
    _contentPages.splice(index, 1);
    // console.log('_contentPages', _contentPages);
    onChange({ contentPages: _contentPages });
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const _contentPages = arrayMove(contentPages, oldIndex, newIndex);
    onChange({ contentPages: _contentPages });
  };

  const childGenerate = (data, index) => {
    const contentPage = get(data, 'contentPage');
    const summary = get(data, 'summary');
    const image = get(data, 'image');
    const subtitle = get(data, 'subtitle');
    const draggableId = get(data, 'draggableId');

    const _specificError = Object.keys(specificError).reduce((pre, now) => {
      if (now.startsWith(draggableId)) {
        const v = specificError[now];

        const item = now.split(draggableId)[1];
        return { ...pre, [item]: v };
      }
      return pre;
    }, {});

    return (
      <_ContentPage
        isPrimary={true}
        specificError={_specificError}
        errKeys={contentErr}
        index={index}
        contentPageList={contentPageList}
        sectionContainer={css.contentPageSectionContainer}
        contentPage={contentPage}
        image={image}
        summary={summary}
        subtitle={subtitle}
        onChange={handleOnItemChange}
        onDelete={() => {
          handleOnItemDelete(index);
        }}
      />
    );
  };

  return (
    <React.Fragment>
      <Section size='small' bottomBorder className={css.posterContainer}>
        <ItemWrapper title={getI18n('general.contentPageInARow')}>
          <OriSelect
            value={contentPagesToShow}
            size='large'
            onChange={handleOnContentTypeChange}>
            {renderContentType()}
          </OriSelect>
        </ItemWrapper>
      </Section>
      {amountErr.length > 0 && (
        <Section size='small' bottomBorder>
          <div className={css.errorContainer}>{amountErr.join('')}</div>
        </Section>
      )}
      {!isConvertible && (
        <DragNDropColumns
          hideTitle
          childGenerate={childGenerate}
          data={contentPages || []}
          droppableId={`salesChannelContentListContentPagesTab${draggableId}`}
          onSort={handleItemOnSort}
          //onDelete={handleOnItemDelete}
          onAdd={() => {
            const _contentPages = [...contentPages];
            const newPage = {
              draggableId: randomNumber(),
              ...generateNewContentPage(),
            };
            _contentPages.push(newPage);
            onChange({ contentPages: _contentPages });
            //setVisible(true);
          }}
          addText={`+ ${getI18n('general.addContentPage')}`}
        />
      )}
    </React.Fragment>
  );
};
